import * as React from "react";

const CustomHeartIcon: React.FC = () => {
    return (
        <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M15.4009 2.20322C15.0196 1.82177 14.5669 1.51917 14.0687 1.31271C13.5704 1.10626 13.0363 1 12.497 1C11.9577 1 11.4236 1.10626 10.9254 1.31271C10.4271 1.51917 9.97442 1.82177 9.59314 2.20322L8.80186 2.99451L8.01057 2.20322C7.24041 1.43307 6.19586 1.0004 5.1067 1.0004C4.01753 1.0004 2.97298 1.43307 2.20282 2.20322C1.43267 2.97338 1 4.01793 1 5.1071C1 6.19626 1.43267 7.24081 2.20282 8.01097L2.99411 8.80225L8.80186 14.61L14.6096 8.80225L15.4009 8.01097C15.7823 7.62969 16.0849 7.17699 16.2914 6.67874C16.4978 6.18048 16.6041 5.64643 16.6041 5.1071C16.6041 4.56776 16.4978 4.03371 16.2914 3.53545C16.0849 3.0372 15.7823 2.5845 15.4009 2.20322Z"
                fill="white"
                stroke="#323132"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default React.memo(CustomHeartIcon);
